import React from "react";
import { withRouter } from "react-router-dom";
import RegisteredPet from "~/components/registeredPet";

const RegisteredPetPage = () => {
	return <RegisteredPet />;
};

export default withRouter(RegisteredPetPage);
